export const MB = 1024 * 1024;
export const GOOGLE_MAX_FILE_SIZE = 5 * MB;
export const META_MAX_FILE_SIZE = 30 * MB;
export const ESPORAI_MAX_FILE_SIZE = 20 * MB;

export const COUNTRIES = [
  // América
  { code: 'ag', name: 'Antigua y Barbuda',               prefix: '+1',     flag: '🇦🇬' },
  { code: 'ar', name: 'Argentina',                        prefix: '+549',   flag: '🇦🇷' },
  { code: 'bs', name: 'Bahamas',                          prefix: '+1',     flag: '🇧🇸' },
  { code: 'bb', name: 'Barbados',                         prefix: '+1',     flag: '🇧🇧' },
  { code: 'bz', name: 'Belice',                           prefix: '+501',   flag: '🇧🇿' },
  { code: 'bo', name: 'Bolivia',                          prefix: '+591',   flag: '🇧🇴' },
  { code: 'br', name: 'Brasil',                           prefix: '+55',    flag: '🇧🇷' },
  { code: 'ca', name: 'Canadá',                           prefix: '+1',     flag: '🇨🇦' },
  { code: 'cl', name: 'Chile',                            prefix: '+56',    flag: '🇨🇱' },
  { code: 'co', name: 'Colombia',                         prefix: '+57',    flag: '🇨🇴' },
  { code: 'cr', name: 'Costa Rica',                       prefix: '+506',   flag: '🇨🇷' },
  { code: 'cu', name: 'Cuba',                             prefix: '+53',    flag: '🇨🇺' },
  { code: 'dm', name: 'Dominica',                         prefix: '+1',     flag: '🇩🇲' },
  { code: 'do', name: 'República Dominicana',             prefix: '+1',     flag: '🇩🇴' },
  { code: 'ec', name: 'Ecuador',                          prefix: '+593',   flag: '🇪🇨' },
  { code: 'sv', name: 'El Salvador',                      prefix: '+503',   flag: '🇸🇻' },
  { code: 'us', name: 'Estados Unidos',                   prefix: '+1',     flag: '🇺🇸' },
  { code: 'gd', name: 'Granada',                          prefix: '+1',     flag: '🇬🇩' },
  { code: 'gt', name: 'Guatemala',                        prefix: '+502',   flag: '🇬🇹' },
  { code: 'gy', name: 'Guyana',                           prefix: '+592',   flag: '🇬🇾' },
  { code: 'ht', name: 'Haití',                            prefix: '+509',   flag: '🇭🇹' },
  { code: 'hn', name: 'Honduras',                         prefix: '+504',   flag: '🇭🇳' },
  { code: 'jm', name: 'Jamaica',                          prefix: '+1',     flag: '🇯🇲' },
  { code: 'mx', name: 'México',                           prefix: '+52',    flag: '🇲🇽' },
  { code: 'ni', name: 'Nicaragua',                        prefix: '+505',   flag: '🇳🇮' },
  { code: 'pa', name: 'Panamá',                           prefix: '+507',   flag: '🇵🇦' },
  { code: 'py', name: 'Paraguay',                         prefix: '+595',   flag: '🇵🇾' },
  { code: 'pe', name: 'Perú',                             prefix: '+51',    flag: '🇵🇪' },
  { code: 'kn', name: 'San Cristóbal y Nieves',           prefix: '+1',     flag: '🇰🇳' },
  { code: 'vc', name: 'San Vicente y las Granadinas',     prefix: '+1',     flag: '🇻🇨' },
  { code: 'lc', name: 'Santa Lucía',                      prefix: '+1',     flag: '🇱🇨' },
  { code: 'sr', name: 'Surinam',                          prefix: '+597',   flag: '🇸🇷' },
  { code: 'tt', name: 'Trinidad y Tobago',                prefix: '+1',     flag: '🇹🇹' },
  { code: 'uy', name: 'Uruguay',                          prefix: '+598',   flag: '🇺🇾' },
  { code: 've', name: 'Venezuela',                        prefix: '+58',    flag: '🇻🇪' },

  // Europa occidental
  { code: 'gb', name: 'Reino Unido',       prefix: '+44',   flag: '🇬🇧' },
  { code: 'ie', name: 'Irlanda',           prefix: '+353',  flag: '🇮🇪' },
  { code: 'fr', name: 'Francia',           prefix: '+33',   flag: '🇫🇷' },
  { code: 'de', name: 'Alemania',          prefix: '+49',   flag: '🇩🇪' },
  { code: 'es', name: 'España',            prefix: '+34',   flag: '🇪🇸' },
  { code: 'pt', name: 'Portugal',          prefix: '+351',  flag: '🇵🇹' },
  { code: 'it', name: 'Italia',            prefix: '+39',   flag: '🇮🇹' },
  { code: 'be', name: 'Bélgica',           prefix: '+32',   flag: '🇧🇪' },
  { code: 'nl', name: 'Países Bajos',      prefix: '+31',   flag: '🇳🇱' },
  { code: 'lu', name: 'Luxemburgo',        prefix: '+352',  flag: '🇱🇺' },
  { code: 'ch', name: 'Suiza',             prefix: '+41',   flag: '🇨🇭' },
  { code: 'at', name: 'Austria',           prefix: '+43',   flag: '🇦🇹' },

  // Europa nórdica y báltica
  { code: 'se', name: 'Suecia',            prefix: '+46',   flag: '🇸🇪' },
  { code: 'no', name: 'Noruega',           prefix: '+47',   flag: '🇳🇴' },
  { code: 'dk', name: 'Dinamarca',         prefix: '+45',   flag: '🇩🇰' },
  { code: 'fi', name: 'Finlandia',         prefix: '+358',  flag: '🇫🇮' },
  { code: 'is', name: 'Islandia',          prefix: '+354',  flag: '🇮🇸' },
  { code: 'ee', name: 'Estonia',           prefix: '+372',  flag: '🇪🇪' },
  { code: 'lv', name: 'Letonia',           prefix: '+371',  flag: '🇱🇻' },
  { code: 'lt', name: 'Lituania',          prefix: '+370',  flag: '🇱🇹' },

  // Europa central y del este
  { code: 'pl', name: 'Polonia',           prefix: '+48',   flag: '🇵🇱' },
  { code: 'cz', name: 'República Checa',   prefix: '+420',  flag: '🇨🇿' },
  { code: 'hu', name: 'Hungría',           prefix: '+36',   flag: '🇭🇺' },
  { code: 'sk', name: 'Eslovaquia',        prefix: '+421',  flag: '🇸🇰' },
  { code: 'si', name: 'Eslovenia',         prefix: '+386',  flag: '🇸🇮' },
  { code: 'hr', name: 'Croacia',           prefix: '+385',  flag: '🇭🇷' },
  { code: 'ro', name: 'Rumanía',           prefix: '+40',   flag: '🇷🇴' },
  { code: 'bg', name: 'Bulgaria',          prefix: '+359',  flag: '🇧🇬' },
  
  // Resto del mundo (selección)
  { code: 'ru', name: 'Rusia',             prefix: '+7',    flag: '🇷🇺' },
  { code: 'jp', name: 'Japón',             prefix: '+81',   flag: '🇯🇵' },
  { code: 'cn', name: 'China',             prefix: '+86',   flag: '🇨🇳' },
  { code: 'au', name: 'Australia',         prefix: '+61',   flag: '🇦🇺' }
];
